// extracted by mini-css-extract-plugin
export default {"GateBody":"stringify_GateBody__YAuQh","WidgetDisabled":"stringify_WidgetDisabled__dACL2"};